<template>
  <div>
    <v-alert v-if="loadFailed" type="error"
      >Не удалось загрузить данные</v-alert
    >
    <div
      v-for="hasp in loadFailed ? [] : $store.state.haspInfo"
      :key="hasp.gid"
      class="white elevation-1 pa-2"
    >
      <div class="title text-center">HASP #{{ hasp.gid }}</div>
      <div class="pa-2 layout">
        <div class="flex xs12 sm4">
          <span class="pr-2">Первый номер:</span>{{ hasp.from }}
        </div>
        <div class="flex xs12 sm4">
          <span class="pr-2">Последний номер:</span>{{ hasp.till }}
        </div>
        <div class="flex xs12 sm4">
          <span class="pr-2">Свободных меток:</span>{{ hasp.free }}
        </div>
      </div>
    </div>
    <div v-if="!loadFailed" class="white elevation-1 pa-4 mt-2">
      <span>Всего свободных меток: {{ getTotalFree }}</span>
    </div>
  </div>
</template>

<script>
import { errorMessage } from "@/utils";
export default {
  name: "OrderPage",
  data() {
    return {
      loadFailed: false,
      loading: false
    };
  },
  methods: {
    async fetchHasp() {
      this.loading = true;
      this.loadFailed = false;
      try {
        await this.$store.dispatch("getHaspInfo");
      } catch (e) {
        this.loadFailed = true;
        this.$store.dispatch("addMessage", {
          text: errorMessage(e),
          type: "error"
        });
      }
      this.loading = false;
    }
  },
  computed: {
    getTotalFree() {
      return this.$store.state.haspInfo.reduce((p, c) => {
        return p + c.free;
      }, 0);
    }
  },
  beforeMount() {
    this.fetchHasp();
  }
};
</script>
